/**
 * Beijing YuanTang International Trade — WYJ clamp/fiber contract manufacturer
 * (`supplier.data.id`; Megaventory supplier 657).
 */
export const CLAMP_FORECAST_WYJ_SUPPLIER_DATA_ID = 1429;

export const CLAMP_FORECAST_WYJ_SUPPLIER_LABEL = "Beijing YuanTang International Trade";

/** Defaults from supplier.data id 1429; API reloads this row when creating POs. */
export const CLAMP_FORECAST_WYJ_DEFAULT_CURRENCY = "CNY";
export const CLAMP_FORECAST_WYJ_DEFAULT_PAYMENT_TERMS = "Net30";

export interface ClampForecastWyjSupplierRow {
  id: number;
  mv_supplier_id: number;
  mv_supplier_name: string;
  currency: string;
  payment_terms: string;
}

export interface ClampForecastAddToPoOption {
  purchase_order_id: number;
  mv_number: string | null;
  supplier_name: string | null;
  line_count: number;
  /** Megaventory PO comments on public.purchase_order.special_instructions. */
  special_instructions: string | null;
}

/** Max characters for PO comments shown in the clamp forecast “Add to PO” dropdown label. */
export const CLAMP_FORECAST_ADD_TO_PO_SPECIAL_INSTRUCTIONS_MAX_LEN = 56;

/** Collapse whitespace and ellipsis-truncate Megaventory PO comments for compact dropdown labels. */
export function truncateClampForecastAddToPoSpecialInstructions(
  instructions: string,
  maxLen: number = CLAMP_FORECAST_ADD_TO_PO_SPECIAL_INSTRUCTIONS_MAX_LEN,
): string {
  const collapsed = instructions.trim().replace(/\s+/g, " ");
  if (collapsed.length <= maxLen) return collapsed;
  return `${collapsed.slice(0, Math.max(1, maxLen - 1))}…`;
}

/** Single-line label for the clamp forecast “Add to PO” dropdown. */
export function formatClampForecastAddToPoOptionLabel(option: ClampForecastAddToPoOption): string {
  const numberLabel = option.mv_number ?? `PO #${option.purchase_order_id}`;
  const lineSuffix = option.line_count === 1 ? "" : ` (${option.line_count} lines)`;
  const instructions = option.special_instructions?.trim() ?? "";
  if (instructions === "") return `${numberLabel}${lineSuffix}`;
  return `${numberLabel}${lineSuffix} — ${truncateClampForecastAddToPoSpecialInstructions(instructions)}`;
}

/** PO header statuses excluded from the clamp forecast “Add to PO” list. */
export function isClampForecastAddToPoPurchaseOrderStatus(mvStatus: string | null | undefined): boolean {
  const lower = (mvStatus ?? "").trim().toLowerCase();
  if (lower === "") return true;
  return lower !== "closed" && lower !== "fullyinvoiced" && lower !== "cancelled" && lower !== "canceled";
}
